<template>
  <div id="playtimeForm" ref="playtimeForm" onclick="event.stopPropagation()"
    :class="[parentAccessorComponentProp]">
    <el-form ref="playtimeElFormRef">
      <!-- Select Schedule Type -->
      <div :class="['schedule-type-wrapper', {'show-all-sched-type': allScheduleTypes, 'hide-all-sched-type': hideAllScheduleTypes }]">
        <el-button-group class="cstm-sched-type-group-btn">
          <template v-for="(item, indx) in modifySchedule.options.type" :key="indx">
            <el-tooltip
              :popper-class="'custom-tooltip-popper'"
              :show-arrow="false"
              effect="light"
              :content="item.toolTip"
              placement="bottom"
              class="item">
              <el-button v-if="item.visible" :key="indx"
                @click="handleScheduleTypeClick(item.value, item.switchTypeVal)"
                :class="[item.elClass, {'is-selected': (modifySchedule.formValues.switchTypeVal === item.switchTypeVal)}]">{{item.label}}
              </el-button>
            </el-tooltip>
          </template>
        </el-button-group>
      </div>

      <!-- Custom Schedule type fields -->
      <template v-if="modifySchedule.formValues.type === scheduleTypeOptions.custom">
        <!-- Days -->
        <el-form-item prop="scheduleRepeatDays" class="f-item-col-item days">
          <el-checkbox-group
            v-model="modifySchedule.formValues.repeatDays"
            @change="handleModifySchedulePropertyChange"
            class="w-full m-[1px]"
          >
            <el-checkbox-button v-for="(item, indx) in modifySchedule.options.days" :value="indx" :key="indx">
              {{item}}
            </el-checkbox-button>
          </el-checkbox-group>
        </el-form-item>

        <!-- Date Range -->
        <div class="schedule-date-wrapper block">
          <div v-if="!modifySchedule.formValues.showDateRange" @click="handleCustomScheduleIconClick('dateRangeIcon')" class="schedule-date-range-icon" ></div>
          <template v-if="modifySchedule.formValues.showDateRange">
            <el-form-item prop="scheduleDateRange" class="f-item-col-item sched-date-range w-full">
              <DateTimePicker
                :showTimeRange="modifySchedule.formValues.showTimeRange"
                :dateTimeValues="modifySchedule.formValues"
                @updateSchedule="handleUpdateFromDateTimePicker"
                />
            </el-form-item>
          </template>
        </div>
      </template>
    </el-form>
    <slot></slot>
  </div>
</template>

<script src="./playtime-form.js"></script>
<style lang="scss" src="./playtime-form.scss"></style>
